import Validator from './class/Validator'

const createValidator = (obj) => {
  return new Validator(obj)
}
export default createValidator
